module.exports = __webpack_public_path__ + "static/media/temp_chart4.27486596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/colonyGame/temp_chart4.png
// module id = 2282
// module chunks = 0